import { Action } from 'redux';

import { isIncrementRouterSpaceReactKeyAction } from '../actions/spaces/IncrementRouterSpaceReactKeyAction';

export const RouterSpaceReactKeyInitial: number = 1;

export function incrementRouterSpaceReactKeyReducer(
  previousKey: number = RouterSpaceReactKeyInitial,
  action: Action = null
): number {

  if(isIncrementRouterSpaceReactKeyAction(action)) {
    return previousKey + 1;
  }

  return previousKey;
}
